import type { ChangeEvent } from '@brighterly/lib-core-types/ui/inputs/interfaces'
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { ReferralSource } from '../enums'
import { useTutorApplicationStore } from '../store'

interface JobPostingSiteReturn {
  mode: ComputedRef<InputMode>
  label: string
  setJobPostingSite: (event: ChangeEvent) => void
}

export const useJobPostingSite = (): JobPostingSiteReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && (tutorApplicationStore.getReferralSource === ReferralSource.JobBoard ? !tutorApplicationStore.jobPostingSite : false)))

  const label = 'Did you find our job posting on a career site? If so, please precise where.'

  const setJobPostingSite = (event: ChangeEvent) => {
    tutorApplicationStore.setJobPostingSite(event.value)
  }

  return {
    mode,
    label,
    setJobPostingSite,
  }
}
